import React, { useState, useEffect } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { FaPlusCircle, FaRegTimesCircle } from 'react-icons/fa'
import { IconButton } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { useQuery } from '@apollo/client'

import VehicleTypes from './Displays/VehicleTypes'
import BaseBin from '../BaseBin'
import { Q_VEHICLE_TYPES } from 'graphql/query'
import VehicleTypeCreate from '../VehicleType/Forms/Create'
import styles from './vehicleType.module.scss'
import Loading from 'components/Global/Loading'
import NoContents from 'components/Global/NoContents'

const VehicleTypesBin = () => {
  const [messages, setMessages] = useState([])
  const [create, setCreate] = useState(false)
  const [loading, setLoading] = useState(true)
  const [vTypes, setVTypes] = useState([])

  const { refetch } = useQuery(Q_VEHICLE_TYPES)
  const concatMessages = msg => {
    setMessages([...messages, msg])
  }
  const [noContents, setNoContents] = React.useState(false)

  const update = () => {
    refetch() &&
      refetch()
        .then(res => {
          setVTypes(res.data.rVehicleType)
          setLoading(false)
        })
        .catch(err => {
          console.error(err)
          setNoContents(true)
        })
  }

  useEffect(() => {
    update()
  }, [refetch])

  return noContents ? (
    <NoContents />
  ) : (
    <div className={styles.root}>
      <BaseBin
        title="VehicleTypes"
        actions={[
          <IconButton
            className={styles.icnButton}
            color="primary"
            onClick={() => setCreate(i => !i)}
          >
            {!create ? <FaPlusCircle /> : <FaRegTimesCircle />}
          </IconButton>,
        ]}
      >
        {!create ? (
          <div className={styles.alertWrapper}>
            <div className={styles.content}>
              {messages.map(message => (
                <Alert variant="filled" severity={message.type}>
                  {message.message}
                </Alert>
              ))}
            </div>
            {!loading ? (
              <VehicleTypes
                setMessages={concatMessages}
                loading={setLoading}
                data={vTypes}
                update={update}
              />
            ) : (
              <Loading />
            )}
          </div>
        ) : (
          <VehicleTypeCreate
            setCreate={setCreate}
            update={update}
            loading={setLoading}
          />
        )}
      </BaseBin>
    </div>
  )
}

export default VehicleTypesBin
